export default function (context, agreement) {
    agreement.requests.forEach(i => {
        switch (context.rootState.finances.pay.form.PaymentDirection) {
            case 0:
                i.sum = i.inp > 0 ? i.inp : 0;
                return;
            case 1:
                i.sum = i.out > 0 ? i.out : 0;
                return;
        }
    });
}